<template>
  <div class="pc-container">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('message.header.home') }}</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/job">{{ $t('message.header.job') }}</a></el-breadcrumb-item>
        <el-breadcrumb-item>{{details.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="job-content">
      <div class="job-main">
        <div class="job-lists">
          <div class="title">{{details.title}}</div>
          <div class="content">
            <span v-html="details.desc"></span>
            <br><br>________________________________________<br>
            {{ $t('message.joinus.emailus') }}<br>
          </div>
        </div>
      </div>
      <job-menu :data="data"></job-menu>
    </div>
  </div>
</template>

<script>
import {jobData} from "@/data";

export default {
  name: 'JobDetailsView',
  data(){
    return {
      data:jobData[1].items||[],
      details:{}
    }
  },
  created() {
    const query = this.$route.query;
    this.details = this.data.find(item=>item.id==query.id);
  }
}
</script>
<style lang="scss" scoped>
.pc-container {
  .job-content {
    text-align: left;
    max-width: 1200px;
    margin: 0 auto;
    padding: 50px 15px;
    display: flex;
    justify-content: space-between;
    align-items: flex-top;
  }
  .breadcrumb {
    width: 1200px;
    margin: auto;
    padding: 20px;
  }
  .job-main {
    .job-lists {
      padding-bottom: 50px;
    }
    .title {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 24px;
      color: #333333;
      line-height: 36px;
      padding-bottom: 60px;
    }
    .content {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: rgba(51, 51, 51, 0.8);
      line-height: 36px;
    }
  }
}
@media (max-width: 768px) {
  .pc-container {
    .job-content {
      display: inline-block;
      padding: 30px 15px;
    }
    .job-main .title {
      font-size: 20px;
      padding-bottom: 30px;
    }
    .job-main .content {
      font-size: 14px;
      line-height: 30px;
    }
    .job-menu {
      width: auto !important;
    }
  }
}
</style>
